import { Box, Button, Stack } from '@mui/material';

import { useModalControl } from 'hooks/useModalControl';
import type { Transfer } from 'restful/tickets';
import { useTicketInviteInvalid } from 'services/datalayer/tickets';

import SettingsLink from 'components/@account/SettingsLink';
import ContactDialog from 'components/@common/ContactDialog';

import InvalidTransferVariants from './InvalidTransferVariants';
import { InvalidTransferVariant } from './types';

interface Props {
  transfer: Transfer | undefined;
  eventInvalid: boolean;
}

const determineVariant = (
  transfer?: Transfer,
  eventInvalid?: boolean,
): InvalidTransferVariant => {
  if (eventInvalid || transfer?.status === 'Expired') return 'expired';
  if (transfer?.status === 'Completed') return 'completed';
  if (transfer?.status === 'Cancelled') return 'cancelled';
  return 'fallback';
};

const InvalidTransfer = ({ transfer, eventInvalid }: Props) => {
  useTicketInviteInvalid({ inviteSource: transfer ? 'direct' : 'none' });
  const { open, onClose, onOpen } = useModalControl();

  const variant = determineVariant(transfer, eventInvalid);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          maxWidth: '560px',
          flexDirection: 'column',
          flex: '1',
        }}
      >
        <Box
          sx={{
            flexGrow: { xs: 1, md: 0 },
            mb: { xs: 0, md: 5 },
          }}
        >
          <InvalidTransferVariants transfer={transfer} variant={variant} />
        </Box>
        {variant === 'fallback' && (
          <>
            <Stack
              sx={{
                mb: 3,
                display: 'flex',
              }}
            >
              <SettingsLink
                iconName="QuestionCircle"
                intlId="account.settings.help"
                component={Button}
                onClick={onOpen}
              />
            </Stack>
            <ContactDialog open={open} onClose={onClose} />
          </>
        )}
      </Box>
    </>
  );
};

export default InvalidTransfer;
